var paragraph_default = {
  "fontElementMap": "Pxw3M",
  "elementSpacing": "VSn1J",
  "text": "l1t8- VSn1J",
  "child": "_1gKbZ"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
